module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-left-down-a6b24cce398e78e6925c7b6cdfd5dc16.svg";